module.exports = __webpack_public_path__ + "static/media/team.1b885c16.png";